import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Log } from 'ng2-logger';
import {environment} from '../../../environments/environment';

const log = Log.create('ConfirmModal');

@Component({
  moduleId: module.id,
  selector: 'confirm-modal',
  templateUrl: 'confirm.component.html',
  styleUrls: ['confirm.less']
})
export class ConfirmFlushComponent {
  @Input() title: string = 'Confirm flush';
  @Input() description: string = 'Flushing all companies for every region can take serveral minutes to finish. Are you sure you want to proceed?';
  @Input() show: boolean = false;
  @Output() confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  baseUrl = environment.BASE_URL;

  onClose(yes: boolean) {
    this.confirmed.emit(yes);
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/confirm/confirm.component.ts